module.exports = __webpack_public_path__ + "img/card.afe06126.png";